import React from 'react'
import { inject, observer } from 'src/core/store'
import './index.less'
import { getlang, setlang, supportedLangs } from 'src/helper/getlang'
import {
  setDocumentTitle,
  setUidToken,
  capitalizeFirstLetter,
  isRtl,
  isVoca,
} from 'src/helper/tool'
import langM from './lang'
import http from 'src/helper/http'
import { jumpToUser } from 'src/helper/webviewFun'
import Toast from '../../../component/Toast'
import MediaModal from 'src/component/media-modal'
import Swiper from 'swiper'
import 'swiper/swiper-bundle.min.css'
import RewardItem from './reward-item'

const fasArrHoby = [
  { avatarurl: '/img/icon-bg.png', nickname: 'Yayya', score: 0 },
  { avatarurl: '/img/icon-bg.png', nickname: 'Yayya', score: 0 },
  { avatarurl: '/img/icon-bg.png', nickname: 'Yayya', score: 0 },
]

const fasArrVoca = [
  { avatarurl: '/img/voca-home/default_avatarurl@2x.webp', nickname: 'Voca', score: 0 },
  { avatarurl: '/img/voca-home/default_avatarurl@2x.webp', nickname: 'Voca', score: 0 },
  { avatarurl: '/img/voca-home/default_avatarurl@2x.webp', nickname: 'Voca', score: 0 },
]
@inject('store')
@observer
export default class HobiRecharge extends React.Component {
  constructor(props) {
    super(props)
    this.swiperRef = React.createRef()
    this.toastRef = React.createRef()
    this.countDownTimer = null
  }

  state = {
    lang: langM.en,
    uid: '',
    language: 'en',
    showMoldRoot: false,
    dayNum: 0,
    hourNum: 0,
    minNum: 0,
    secondNum: 0,
    rewardIndex: 0,
    fasArr: isVoca() ? fasArrVoca : fasArrHoby,
    showItem: 0,
    wewbase: '',
    showUrl: '',
    rechargeItem: 0,
    monthlyTotal: '',
    toastContent: '',
    bigimg: { pic: '' },
    bigimgTwo: { pic: '' },
    getTrobj: {},
    mediaVisible: false,
    activeMedia: {},
    gearsItemList: [],
    listTier990: [],
    listTier50000: [],
    listTier300000: [],
    bannerList: supportedLangs.reduce(
      (acc, lang) => ({ ...acc, [lang]: `/img/activity/hobiRecharge/banner_${lang}.png` }),
      {},
    ),
  }

  reportWhiteScreenTime = () => {
    try {
      const paintEntries = performance.getEntriesByType('paint')
      const fcp = paintEntries.find((e) => e.name === 'first-contentful-paint')
      const fp = paintEntries.find((e) => e.name === 'first-paint')
      const whiteScreenTime = fcp ? fcp.startTime : fp ? fp.startTime : null
      if (whiteScreenTime != null) {
        console.log('[hobiRecharge] 白屏时间:', Math.round(whiteScreenTime), 'ms')
        return
      }
      const observer = new PerformanceObserver((list) => {
        for (const entry of list.getEntries()) {
          if (entry.name === 'first-contentful-paint' || entry.name === 'first-paint') {
            console.log('[hobiRecharge] 白屏时间:', Math.round(entry.startTime), 'ms')
            observer.disconnect()
            return
          }
        }
      })
      observer.observe({ type: 'paint', buffered: true })
    } catch (e) {
      if (performance.timing) {
        const t = performance.timing
        const fallback = t.responseEnd - t.navigationStart
        if (fallback >= 0) console.log('[hobiRecharge] 白屏时间(近似):', fallback, 'ms')
      }
    }
  }

  async componentDidMount() {
    performance.mark('hobiRecharge-mount-start')
    this.reportWhiteScreenTime()
    const { location } = this.props
    let language = await getlang(location.query && location.query.language)
    const currentLang = setlang(language, langM)
    if (isVoca()) {
      for (const key in currentLang) {
        if (currentLang[key] && typeof currentLang[key] === 'string') {
          currentLang[key] = currentLang[key].replace(/(Yayya|hoby)/, 'Voca')
        }
        if (Array.isArray(currentLang[key])) {
          currentLang[key] = currentLang[key].map((item) => {
            if (typeof item === 'string') {
              return item.replace(/(Yayya|hoby)/, 'Voca')
            }
            return item
          })
        }
      }
    }
    const gearsItemList = [currentLang.nineAdd, currentLang.fiveAdd, currentLang.threeAdd]
    this.setState(
      {
        lang: currentLang,
        language,
        rechargeItem: isRtl(language) ? 2 : 0,
        gearsItemList: isRtl(language) ? gearsItemList.reverse() : gearsItemList,
      },
      () => {
        setDocumentTitle(this.state.lang.recharge_activity)
      },
    )
    const uid = await setUidToken(location.query)
    await this.RunOnStart(uid)
    this.initSwiper(language)
  }

  componentWillUnmount() {
    if (this.countDownTimer) {
      clearInterval(this.countDownTimer)
    }
  }

  RunOnStart = async (uid) => {
    this.setState({ uid })
    this.getUidInfo(uid)
    this.getCownTime()
    this.getRechargeList()
  }

  async getCownTime() {
    let res = await http.post('/web/newrechargeReward/countdown')
    if (res.code === 0) {
      this.setState({ monthlyTotal: res.data.monthlyTotal, coins: res.data.dollar2GoldRate })
      this.countDown(res.data.leftTimestamp)
    }
  }

  countDown = (times) => {
    if (this.countDownTimer) {
      clearInterval(this.countDownTimer)
      this.countDownTimer = null
    }
    if (times <= 0) return
    const tick = () => {
      let day = 0
      let hour = 0
      let minute = 0
      let second = 0
      if (times > 0) {
        day = Math.floor(times / (60 * 60 * 24))
        hour = Math.floor(times / (60 * 60)) - day * 24
        minute = Math.floor(times / 60) - day * 24 * 60 - hour * 60
        second = Math.floor(times) - day * 24 * 60 * 60 - hour * 60 * 60 - minute * 60
      }
      if (hour <= 9) hour = '0' + hour
      if (minute <= 9) minute = '0' + minute
      if (second <= 9) second = '0' + second
      this.setState({
        dayNum: day,
        hourNum: hour,
        minNum: minute,
        secondNum: second,
      })
      times--
      if (times <= 0 && this.countDownTimer) {
        clearInterval(this.countDownTimer)
        this.countDownTimer = null
      }
    }
    this.countDownTimer = setInterval(tick.bind(this), 1000)
  }

  getRechargeList = async () => {
    const res = await http.post('/web/newrechargeReward/rewardList')
    if (res.code === 0) {
      const list = res.data.list || []
      const TIER_990 = 990
      const TIER_50000 = 50000
      const TIER_300000 = 300000
      const listTier990 = list
        .filter((item) => item.rechargeAmount >= TIER_990 && item.rechargeAmount < TIER_50000)
        .sort((a, b) => a.rechargeAmount - b.rechargeAmount)
      const listTier50000 = list
        .filter((item) => item.rechargeAmount >= TIER_50000 && item.rechargeAmount < TIER_300000)
        .sort((a, b) => a.rechargeAmount - b.rechargeAmount)
      const listTier300000 = list
        .filter((item) => item.rechargeAmount >= TIER_300000)
        .sort((a, b) => a.rechargeAmount - b.rechargeAmount)
      console.log('listTier990', listTier990)
      console.log('listTier50000', listTier50000)
      console.log('listTier300000', listTier300000)

      this.setState(
        {
          listTier990,
          listTier50000,
          listTier300000,
        },
        () => {
          try {
            performance.mark('hobiRecharge-list-ready')
            performance.measure(
              'hobiRecharge-activity-first-screen',
              'hobiRecharge-mount-start',
              'hobiRecharge-list-ready',
            )
            const measures = performance.getEntriesByName('hobiRecharge-activity-first-screen')
            if (measures.length > 0) {
              const ms = Math.round(measures[0].duration)
              console.log('[hobiRecharge] 活动首屏时间(接口+渲染):', ms, 'ms')
            }
            console.log('[hobiRecharge] 从导航到活动首屏:', Math.round(performance.now()), 'ms')
          } catch (e) {
            // ignore
          }
        },
      )
    }
  }

  getUidInfo = async (uid) => {
    let res = await http.post('/web/MyAccountInfo', { uid })
    if (res.code === 0) {
      this.setState({
        userInfo: res.data,
      })
    }
  }

  getReceive = async (e) => {
    let { lang } = this.state
    if (!e.alreadyGet && e.canGet) {
      let res = await http.post('/web/newrechargeReward/getReward', { rechargeLevelId: e.id })
      if (res.code === 0) {
        await this.getRechargeList()
        this.setState({ toastContent: lang.receive_successfully_toast }, () => {
          if (this.toastRef.current) this.toastRef.current.hideRule(true)
        })
      } else {
        this.setState({ toastContent: lang.receive_failed_toast }, () => {
          if (this.toastRef.current) this.toastRef.current.hideRule(true)
        })
      }
    }
  }

  handleSelectItme = (e) => {
    if (this.swiperInstance) {
      this.swiperInstance.slideTo(e)
      this.setState({ rechargeItem: e })
    }
  }

  getName(e) {
    let { language } = this.state
    return e[`rewardName${capitalizeFirstLetter(language)}`] || e.rewardName
  }

  getTopOneRoot = (e) => {
    if (e && e.length >= 1) {
      return (
        <div className="top-one">
          <div className="img-root" onClick={() => this.handleJt(e[0].uid)}>
            <img className="one-head" src="/img/activity/hobiRecharge/top_one_head.png"></img>
            <img className="one-atv" src={e[0].avatarurl}></img>
          </div>
          <div className="name">{e[0].nickname}</div>
        </div>
      )
    } else {
      return <div></div>
    }
  }

  getTopTwoRoot = (e) => {
    if (e && e.length >= 2) {
      return (
        <div className="top-two">
          <div className="img-root">
            <img
              className="two-head"
              onClick={() => {
                this.handleJt(e[1].uid)
              }}
              src="/img/activity/hobiRecharge/top_two_head.png"
            ></img>
            <img className="two-atv" src={e[1].avatarurl}></img>
          </div>
          <div className="name">{e[1].nickname}</div>
        </div>
      )
    } else {
      return <div></div>
    }
  }

  getTopThreeRoot = (e) => {
    if (e && e.length >= 3) {
      return (
        <div className="top-three">
          <div className="img-root">
            <img
              className="three-head"
              onClick={() => this.handleJt(e[2].uid)}
              src="/img/activity/hobiRecharge/top_three_head.png"
            ></img>
            <img className="three-atv" src={e[2].avatarurl}></img>
          </div>
          <div className="name">{e[2].nickname}</div>
        </div>
      )
    } else {
      return <div></div>
    }
  }

  getItemRe = (e) => {
    let { lang, language } = this.state
    let conf = e && e
    let uee = !conf.canGet ? conf.canGet : !conf.alreadyGet
    let langtext = conf.alreadyGet ? lang.received : lang.receive
    return (
      <div
        style={{ paddingTop: `${language === 'ar' ? '0.18rem' : '0.22rem'}` }}
        className={`${!uee ? 'recive-btn-get' : 'recive-btn'} `}
        onClick={() => this.getReceive(e)}
      >
        {langtext}
      </div>
    )
  }

  giftIconTost = async (e) => {
    if (e.rewardType !== 'customized_gift_toast') return
    this.setState({ showMoldRoot: true, showItem: 3 })
    /* debugger
    await this.setState({ toastContent: lang.gift_icon_tost })
    this.refs.toast.hideRule(true) */
  }

  // 设置播放对象
  onSetActiveMedia = async (media) => {
    if (!media.svga) return

    const isMp4ByUrl =
      media.svga && typeof media.svga === 'string' && media.svga.toLowerCase().includes('.mp4')

    const vapJson = {
      horse: {
        info: {
          v: 2,
          f: 120,
          w: 400,
          h: 750,
          fps: 30,
          videoW: 608,
          videoH: 752,
          aFrame: [404, 0, 200, 375],
          rgbFrame: [0, 0, 400, 750],
          isVapx: 0,
          orien: 0,
        },
      },
      entry: {
        info: {
          v: 2,
          f: 48,
          w: 732,
          h: 189,
          fps: 16,
          videoW: 736,
          videoH: 288,
          aFrame: [0, 193, 366, 94],
          rgbFrame: [0, 0, 732, 189],
          isVapx: 0,
          orien: 0,
        },
      },
      decoration: {
        info: {
          v: 2,
          f: 120,
          w: 750,
          h: 1624,
          fps: 30,
          videoW: 1136,
          videoH: 1632,
          aFrame: [754, 0, 375, 812],
          rgbFrame: [0, 0, 750, 1624],
          isVapx: 0,
          orien: 0,
        },
      },
      gift: {
        info: {
          v: 2,
          f: 120,
          w: 400,
          h: 750,
          fps: 30,
          videoW: 608,
          videoH: 752,
          aFrame: [404, 0, 200, 375],
          rgbFrame: [0, 0, 400, 750],
          isVapx: 0,
          orien: 0,
        },
      },
    }

    const vapParams = {
      show_url: media.svga,
      vap_json: isMp4ByUrl ? vapJson[media.rewardType] : media.vapInfo,
      // vap_json: media.vapInfo,
      is_MP4: !!isMp4ByUrl,
    }

    this.setState({
      activeMedia: vapParams,
      mediaVisible: true,
    })

    console.log('vap播放', vapParams)

    // const deviceInfo = (await getDeviceInfo()) || { code: -1 }
    // if (Number(deviceInfo.code) === 0) {
    //   console.log('原生播放')
    //   toAppShow({
    //     loopUrl: media.svga,
    //     loop: 1,
    //     loopType: getMediaType(media.show_type, media.svga),
    //     width：0,
    //     height: 0,
    //   })
    // } else {
    //   const isMp4ByUrl =
    //     media.svga && typeof media.svga === 'string' && media.svga.toLowerCase().includes('.mp4')
    //   console.log('h5播放', isMp4ByUrl)
    //   this.setState({
    //     activeMedia: {
    //       show_url: media.svga,
    //       vap_json: media.vap_json,
    //       is_MP4: !!isMp4ByUrl,
    //     },
    //     mediaVisible: true,
    //   })
    // }
  }

  // 关闭 MediaModal
  onCloseMediaModal = () => {
    this.setState({
      mediaVisible: false,
      activeMedia: {},
    })
  }

  handleJt = (uid) => {
    jumpToUser(uid)
  }

  initSwiper = (language) => {
    const currentLang = language || this.state.language
    this.swiperInstance = new Swiper(this.swiperRef.current, {
      autoplay: false,
      slidesPerView: 1,
      initialSlide: isRtl(currentLang) ? 2 : 0,
      autoHeight: true,
    })

    this.swiperInstance.on('slideChange', (slide) => {
      const { activeIndex } = slide
      this.setState({ rechargeItem: activeIndex })
    })
  }

  render() {
    let {
      language,
      lang,
      showMoldRoot,
      rechargeItem,
      showItem,
      wewbase,
      showUrl,
      dayNum,
      hourNum,
      minNum,
      secondNum,
      monthlyTotal,
      toastContent,
      mediaVisible,
      activeMedia,
      gearsItemList,
      bannerList,
    } = this.state

    const rule4Replace = lang.recharge_activity_rules_4
      .replace('13553434729', '17722823169')
      .replace('13650802365', '17722823169')

    const rules4Text =
      this.state.userInfo && this.state.userInfo.region === 'th'
        ? rule4Replace
        : lang.recharge_activity_rules_4

    const tierList = [this.state.listTier990, this.state.listTier50000, this.state.listTier300000]
    const actTierList = isRtl(language) ? [...tierList].reverse() : tierList
    const currentTierList = actTierList[rechargeItem]

    console.log('language', language)

    return (
      <div className={`hobiRecharge ${isRtl(language) ? 'arlang' : ''}`}>
        <Toast
          language={language}
          lang={lang}
          ref={this.toastRef}
          id="toast"
          toastContent={toastContent}
        />
        <div
          className="hobiRecharge-banner"
          style={{ backgroundImage: `url(${bannerList[language] || bannerList['en']})` }}
        >
          <div
            style={{ justifyContent: `${isRtl(language) ? '' : 'flex-end'}` }}
            className="rules_btn"
            onClick={() => this.setState({ showMoldRoot: true, showItem: 0 })}
          >
            <div className="rules_text_img">{lang.rules}</div>
          </div>
          <div className="time-roots">
            {[
              [lang.days, dayNum],
              [lang.hours, hourNum],
              [lang.minutes, minNum],
              [lang.seconds, secondNum],
            ].map((item, index) => (
              <div
                className="item-in"
                key={index}
                style={{ [isRtl(language) ? 'marginLeft' : 'marginRight']: '0.6rem' }}
              >
                <div className="num">{item[1]}</div>
                <div className="texts2">{item[0]}</div>
              </div>
            ))}
          </div>
        </div>
        <div className="my-chaneg">
          <div className="ins-title">
            <div className="name-text">{lang.my_monthly_recharge}</div>
          </div>
          <div className="rech-body">
            <div className="men-icon">$</div>
            <div className="meny-num">
              <span>{monthlyTotal}</span>
              <img
                className="user-rules-icon"
                onClick={() => {
                  this.setState({ showMoldRoot: true, showItem: 2 })
                }}
                src="/img/activity/hobiRecharge/my_rechaege_rules_icon.png"
                style={{ [isRtl(language) ? 'left' : 'right']: '-0.44rem' }}
              ></img>
            </div>
          </div>
        </div>
        <div className="gears-item" style={{ direction: `${isRtl(language) ? 'ltr' : 'inherit'}` }}>
          {gearsItemList.length > 0 &&
            gearsItemList.map((item, index) => {
              return (
                <div
                  className={`show-intem ${rechargeItem === index ? 'in' : 'no'}`}
                  key={index}
                  onClick={() => this.handleSelectItme(index)}
                >
                  {item}
                </div>
              )
            })}
        </div>
        <div
          className="swiper-container"
          ref={this.swiperRef}
          style={{ direction: isRtl(language) ? 'ltr' : 'inherit' }}
        >
          <div className="swiper-wrapper reward-tier-list">
            {currentTierList.map((item, index) => (
              <RewardItem
                key={item.id}
                reward={item}
                onGiftClick={this.giftIconTost}
                onMediaClick={this.onSetActiveMedia}
                getName={(rewardItem) => this.getName(rewardItem)}
                lang={this.state.lang}
                language={this.state.language}
                onReceive={this.getReceive}
                renderTopOneRoot={this.getTopOneRoot}
                renderTopTwoRoot={this.getTopTwoRoot}
                renderTopThreeRoot={this.getTopThreeRoot}
              />
            ))}
          </div>
        </div>
        <div className="activity-tips">
          <div className="opew">{lang.eid_al_adha_events_button_introduction_1}</div>
          <div className="opw">{lang.eid_al_adha_events_button_introduction_2}</div>
        </div>
        {showMoldRoot && (
          <div
            className="show-rules-modle"
            onClick={() => this.setState({ showMoldRoot: false, showItem: 0 })}
          >
            <div>
              <div
                className="close_icon_root"
                style={{ textAlign: `${isRtl(language) ? 'left' : 'right'}` }}
              >
                <img
                  className="colse-icon-mig"
                  onClick={() => this.setState({ showMoldRoot: false, showItem: 0 })}
                  src="/img/activity/hobiRecharge/close_icon.png"
                ></img>
              </div>
              {(showItem === 0 || showItem === 2) && (
                <div
                  className={`${showItem === 0 ? 'rules-root' : 'myrules-root'}`}
                  onClick={(e) => e.stopPropagation()}
                >
                  <div className="rule-title">
                    {showItem === 0 ? lang.rules : lang.my_monthly_recharge}
                  </div>
                  <div
                    style={{ height: `${showItem === 0 ? '6.88rem' : '5.98rem'}` }}
                    className="inseew"
                  >
                    {showItem === 0 && (
                      <div className="rules-connten-text">
                        <div>{lang.recharge_activity_rules_1}</div>
                        <div>{lang.recharge_activity_rules_2}</div>
                        <div>{lang.recharge_activity_rules_3}</div>
                        <div>{rules4Text}</div>
                      </div>
                    )}
                    {showItem === 2 && (
                      <div className="rules-connten-text">
                        <div>{lang.my_monthly_recharge_rule1(this.state.coins)}</div>
                        <div>{lang.my_monthly_recharge_rule2}</div>
                      </div>
                    )}
                  </div>
                </div>
              )}
              {showItem === 3 && (
                <div className="gift-customize-root" onClick={(e) => e.stopPropagation()}>
                  <div className="rule-title">{lang.customized_gifts_title}</div>
                  <div className="rules-connten-text">
                    <div>{lang.gift_icon_tost}</div>
                  </div>
                </div>
              )}
              {showItem === 1 && (
                <div className="show-gift-show" onClick={(e) => e.stopPropagation()}>
                  {wewbase === 'svga' && (
                    <div
                      className="show-innew"
                      id="show-innew"
                      src={showUrl}
                      onClick={(e) => e.stopPropagation()}
                    ></div>
                  )}
                  {wewbase === 'mp4' && (
                    <video
                      className="show-innew"
                      autoPlay
                      loop
                      muted
                      play="true"
                      playsInline={true}
                      webkit-playsinline="true"
                      onClick={(e) => e.stopPropagation()}
                    >
                      <source src={showUrl} type="video/mp4" />
                    </video>
                  )}
                </div>
              )}
            </div>
          </div>
        )}

        <MediaModal visible={mediaVisible} media={activeMedia} onClose={this.onCloseMediaModal} />
      </div>
    )
  }
}



// WEBPACK FOOTER //
// src/pages/activity/hobiRecharge/index.js